<template>
  <div>
    <el-tabs v-model="activeName">
      <el-tab-pane label="库存表" name="RegisterReport">
        <register-report ref="RegisterReport" />
      </el-tab-pane>

      <el-tab-pane label="审核岗达成情况统计" name="AuditPostReport">
        <audit-post-report ref="AuditPostReport" />
      </el-tab-pane>

      <el-tab-pane label="月度出库统计报表" name="MonthOutCountReport">
        <month-out-count-report ref="MonthOutCountReport" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import AuditPostReport from './components/AuditPostReport'
import MonthOutCountReport from './components/MonthOutCountReport'
import RegisterReport from './components/RegisterReport'

export default {

  name: 'Report',
  components: {
    AuditPostReport,
    MonthOutCountReport,
    RegisterReport
  },

  data() {
    return {
      activeName: 'RegisterReport'
    }
  }
}
</script>

<style>

</style>
